import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckSquare, faSquare } from "@fortawesome/free-solid-svg-icons";
import React from "react";

interface Props {
  value: boolean;
  onChange: (shown: boolean) => void;
}

const NamesControl: React.FC<Props> = ({ value, onChange }) => {
  if (value) {
    return (
      <div>
        <b>Skjul navne</b>
        <Button
          size="sm"
          variant="primary"
          title="Skjul køretøjs navne"
          onClick={() => onChange(false)}
        >
          <FontAwesomeIcon icon={faCheckSquare} />
        </Button>
      </div>
    );
  }

  return (
    <div>
      <b>Vis navne</b>
      <Button
        size="sm"
        variant="secondary"
        title="Vis køretøjs navne"
        onClick={() => onChange(true)}
      >
        <FontAwesomeIcon icon={faSquare} />
      </Button>
    </div>
  );
};

export default NamesControl;
